import {useState} from "react";
import {useFormContext, Controller} from "react-hook-form";
import {GetTransportCompaniesList} from "services/api_v2/Processes/Processes.service";
import {CustomAutocomplete} from "ui";
import {AutoCompleteData} from "ui/CustomAutoComplete/CustomAutoComplete";
import useChangeDAteAndAutocomplete from "views/ProcessDetails/hooks/useChangeDAteAndAutocomplete";
import useHandleFieldLists from "views/ProcessDetails/hooks/useHandleFieldLists";
import {getTooltipText} from "views/ProcessDetails/utils/getTooltipText";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageDTATransportCompany = (props: Props) => {
  const {index, disabled} = props;
  const formatTransportCompanyFn = (data) => {
    return data?.data?.map((item) => ({
      label: `${item?.person?.name} - ${item?.idPerson}`,
      id: item?.person?.id,
    }));
  };

  const {
    getOptions: getTransportCompanyOptions,
    onBottomScroll: onBottomScrollTransportCompany,
    isLoadingOptions: isLoadingTransportCompanyOptions,
  } = useHandleFieldLists(GetTransportCompaniesList, formatTransportCompanyFn);

  const {handleChangeAutocomplete, mountOptions} =
    useChangeDAteAndAutocomplete();
  const {control} = useFormContext<Process>();

  const [transportCompanyOptions, setTransportCompanyOptions] = useState(
    [] as AutoCompleteData[],
  );

  const [search, setSearch] = useState("");

  return (
    <Controller
      name={
        `boarding.voyages.${index}.transportCompany.person` as `boarding.voyages.0.transportCompany.person`
      }
      control={control}
      render={({field: {value}}) => (
        <CustomAutocomplete
          disabled={disabled}
          optionSecondaryContent
          fullWidth
          textFieldProps={{
            label: "Companhia",
          }}
          name={
            `boarding.voyages.${index}.transportCompany.person` as `boarding.voyages.0.transportCompany.person`
          }
          placeholder="Companhia"
          tooltipText={getTooltipText(value?.name ?? "")}
          loading={isLoadingTransportCompanyOptions}
          options={mountOptions(value, transportCompanyOptions)}
          value={value?.name ?? null}
          onOpen={() =>
            getTransportCompanyOptions(setTransportCompanyOptions, 1, search)
          }
          onInputChange={(e, value) => {
            if (e !== null) {
              setSearch(value);
              getTransportCompanyOptions(setTransportCompanyOptions, 1, value);
            }
          }}
          getNextPage={() => {
            onBottomScrollTransportCompany(setTransportCompanyOptions, search);
          }}
          onChange={(e, value) => {
            handleChangeAutocomplete(
              e,
              value,
              `boarding.voyages.${index}.transportCompany.person`,
            );
          }}
          isOptionEqualToValue={(option, value) => value === option?.label}
        />
      )}
    />
  );
};

export default VoyageDTATransportCompany;
